<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>시민참여활동</h2>
            </div>

            <div class="sch_condition_wrap">
                <div class="left _column _flex">
                    <div class="checkbox_wrap sch_list">
                        <label>
                            <input type="checkbox" value="all" v-model="state.selectedType" @change="toggleAllRole" />
                            <em></em>
                            <span>전체</span>
                        </label>

                        <label v-for="item in type_list" :key="item.key">
                            <input type="checkbox" :value="item.key" v-model="state.selectedType" @change="handleRoleChange" />
                            <em></em>
                            <span>{{ item.value }}</span>
                        </label>
                    </div>

                    <div class="_flex _align_bottom _multi">
                        <div class="select_tab_box_wrap">
                            <span class="sch_list_tit">진행상태</span>
                            <div class="select_tab_box _130">
                                <div
                                    class="selected_tab"
                                    :class="[state.isShowState ? 'active' : '']"
                                    @click="state.isShowState = !state.isShowState"
                                >
                                    <span>{{ state.searchStateType }}</span>
                                </div>
                                <div class="tab_option">
                                    <button
                                        v-for="item in state_list"
                                        @click="
                                            state.searchState = item.key;
                                            state.searchStateType = item.value;
                                            state.isShowState = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        {{ item.value }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="select_tab_box_wrap">
                            <span class="sch_list_tit">선발상태</span>
                            <div class="select_tab_box _130">
                                <div
                                    class="selected_tab"
                                    :class="[state.isShowApplyState ? 'active' : '']"
                                    @click="state.isShowApplyState = !state.isShowApplyState"
                                >
                                    <span>{{ state.searchApplyStateType }}</span>
                                </div>
                                <div class="tab_option">
                                    <button
                                        v-for="item in apply_state_list"
                                        @click="
                                            state.searchApplyState = item.key;
                                            state.searchApplyStateType = item.value;
                                            state.isShowApplyState = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        {{ item.value }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="select_date_wrap">
                            <div class="select_date">
                                <input type="date" @keydown.enter="searchDate" name="" id="" v-model="form_state.startDate" @change="getList" />
                            </div>
                            <div class="select_date">
                                <input
                                    style="margin-left: 5px"
                                    type="date"
                                    @keydown.enter="searchDate"
                                    name=""
                                    id=""
                                    v-model="form_state.endDate"
                                    @change="getList"
                                />
                            </div>
                        </div>
                        <div class="search_wrap">
                            <input
                                type="text"
                                v-model="state.searchText"
                                @keyup.enter="
                                    state.page = 1;
                                    getList();
                                "
                                placeholder="제목을 입력하세요."
                            />
                            <button
                                type="button"
                                class="search_btn icon_wrap"
                                @click="
                                    state.page = 1;
                                    getList();
                                "
                            >
                                <img src="img/search_btn.png" alt="" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="right _align_bottom _flex">
                    <button type="button" class="default_btn _blue" @click="addActivity">반성매매 시민활동 등록</button>
                    <button type="button" class="default_btn _blue" @click="addEvent">캠페인·이벤트 등록</button>
                    <button type="button" class="default_btn _blue" @click="addNews">감시뉴스 등록</button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 140px" />
                        <col />
                        <col style="width: 80px" />
                        <col style="width: 120px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 170px" />
                        <col style="width: 100px" />
                        <col style="width: 70px" />
                        <col style="width: 70px" />
                        <col style="width: 70px" />
                        <col style="width: 70px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>게시판 이름</th>
                            <th>제목</th>
                            <th>조회수</th>
                            <th>작성자</th>
                            <th>모집 시작일</th>
                            <th>모집 종료일</th>
                            <th>신청 종료일</th>
                            <th>작성일</th>
                            <th>진행상태</th>
                            <th>선발상태</th>
                            <th>썸네일</th>
                            <th>메인추가</th>
                            <th>수정</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td>{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td class="underline">
                                    <a :href="state.userSiteUrl + '/#/' + (item.type === 4 ? 'news' : 'board?type=' + +item.type)" target="_blank">
                                        {{ strBoardType(item.type) }}
                                    </a>
                                </td>

                                <td class="ellipsis_1 underline">
                                    <a
                                        :href="
                                            state.userSiteUrl +
                                            '/#/' +
                                            (item.type === 1 ? 'activityView/' : item.type === 2 ? 'eventView/' : 'newsView/') +
                                            item.idx
                                        "
                                        target="_blank"
                                    >
                                        {{ item.title }}
                                    </a>
                                </td>
                                <td class="p_5">{{ CommonUtils.numberFormat(item.viewCnt) }}</td>
                                <td>{{ item.writer }}</td>
                                <td class="cnt">
                                    {{
                                        item.recruitStartDate != null && item.type === 1
                                            ? CommonUtils.dateFormatYY(new Date(item.recruitStartDate), ".")
                                            : ""
                                    }}
                                </td>
                                <td class="cnt">
                                    {{
                                        item.recruitEndDate != null && item.type === 1
                                            ? CommonUtils.dateFormatYY(new Date(item.recruitEndDate), ".")
                                            : ""
                                    }}
                                </td>
                                <td class="cnt">
                                    {{ item.applyDate != null ? CommonUtils.dateFormatYY(new Date(item.applyDate), ".") : "" }}
                                </td>
                                <td class="cnt">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                <td class="cnt">{{ item.type === 1 ? strState(item.state) : "" }}</td>
                                <td class="cnt">{{ item.type !== 4 ? (item.applyState === 1 ? "완료" : "미완료") : "" }}</td>
                                <td class="cnt">
                                    <button type="button" class="tb_img img_wrap" @click="viewImage(item.thumbnail)" v-if="item.thumbnail">
                                        <img :src="item.thumbnail" alt="" />
                                    </button>
                                </td>
                                <td class="cnt checkbox_wrap _plus">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input
                                            type="checkbox"
                                            :id="'chk_' + item.idx"
                                            :checked="item.isMain === 1"
                                            @click.prevent="isMain(item.idx)"
                                        />
                                        <em></em>
                                    </label>
                                </td>
                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="showModal(item.type, item.idx)">수정</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="13">
                                <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                :data="state.data"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ActivityModal
        v-if="state.isActivityShowModal"
        :data="state.activityInfo"
        @close="state.isActivityShowModal = false"
        @callback="
            state.isActivityShowModal = false;
            getList();
        "
    ></ActivityModal>

    <EventModal
        v-if="state.isEventShowModal"
        :data="state.eventInfo"
        @close="state.isEventShowModal = false"
        @callback="
            state.isEventShowModal = false;
            getList();
        "
    ></EventModal>

    <NewsModal
        v-if="state.isNewsShowModal"
        :data="state.newsInfo"
        @callback="
            state.isNewsShowModal = false;
            getList();
        "
        @close="state.isNewsShowModal = false"
    ></NewsModal>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        CommonUtils,
        PageBtn,
        ActivityModal,
        NewsModal,
        EventModal,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, ActivityModal, NewsModal, EventModal },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const state = reactive({
                list: [] as Array<any>,
                data: {},
                qnaInfo: {},

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                searchType: "" as string,
                searchText: "" as string,
                startDate: "" as string,
                endDate: "" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                typeTxt: "전체" as string, // 1: 반성매매 시민활동 2: 캠페인/이벤트 4: 감시소식
                searchStateType: "전체" as string, // 진행 상태
                searchApplyStateType: "전체" as string, // 선발 상태

                selectedType: ["all"], // 게시판 타입 리스트
                typeList: [] as Array<string>, // 선택한 게시판 타입 리스트

                isShowState: false as boolean,
                isShowApplyState: false as boolean,

                searchState: null as number | null, // 진행 상태
                searchApplyState: null as number | null, // 선발 상태

                userSiteUrl: process.env.VUE_APP_USER_FRONT_ADDRESS,

                isActivityShowModal: false as boolean,
                activityInfo: {} as any,
                isEventShowModal: false as boolean,
                eventInfo: {} as any,
                isNewsShowModal: false as boolean,
                newsInfo: {} as any,
            });

            const form_state = reactive({
                startDate: "" as string,
                endDate: "" as string,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
            });

            onBeforeUnmount(() => {});

            watch(global, () => {});
            watch(popup, () => {});
            watch(
                () => state.searchText,
                (newVal, oldVal) => {
                    if (oldVal && newVal === "") {
                        getList();
                    }
                },
            );

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {};

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const type_list = [
                { id: "1", key: "1", value: "반성매매 시민활동" },
                { id: "2", key: "2", value: "캠페인·이벤트" },
                { id: "4", key: "4", value: "감시소식" },
            ];

            const state_list = [
                { id: "all", key: 0, value: "전체" },
                { id: "1", key: 1, value: "대기중" },
                { id: "2", key: 2, value: "진행중" },
                { id: "2", key: 3, value: "진행종료" },
            ];
            const apply_state_list = [
                { id: "all", key: null, value: "전체" },
                { id: "1", key: 0, value: "대기중" },
                { id: "2", key: 1, value: "완료" },
            ];

            const strBoardType = (val: number) => {
                switch (val) {
                    case 1:
                        return "반성매매 시민활동";
                    case 2:
                        return "캠페인·이벤트";

                    default:
                        return "감시소식";
                }
            };

            const strState = (val: number) => {
                switch (val) {
                    case 1:
                        return "대기중";
                    case 2:
                        return "진행중";
                    case 3:
                        return "진행종료";

                    default:
                        return "기타";
                }
            };

            const searchDate = async () => {
                if (form_state.startDate && form_state.endDate) {
                    if (form_state.endDate < form_state.startDate) {
                        form_state.endDate = "";
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "날짜를 올바르게 선택해주세요.";
                        state.isShowModal = true;
                        return;
                    }
                }
                state.startDate = form_state.startDate;
                state.endDate = form_state.endDate;
                state.page = 1;
                getList();
            };

            const getList = async () => {
                const param: types.ReqBoardListForActivity = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,

                    typeList: String(state.typeList),
                    state: state.searchState,
                    applyState: state.searchApplyState,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                if (!state.selectedType.includes("all")) {
                    param.typeList = state.selectedType.join(",");
                }

                const res = await apiService.board.listForActivity(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const isMain = async (idx: number) => {
                const res = await apiService.board.pick(idx);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "등록이 완료되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "등록이 불가능 합니다.";
                    state.isShowModal = true;
                }
                await getList();
            };

            const toggleAllRole = () => {
                if (state.selectedType.includes("all")) {
                    state.selectedType = ["all"];
                } else {
                    state.selectedType = [];
                }
                state.page = 1;
                getList();
            };

            const handleRoleChange = () => {
                if (state.selectedType.includes("all") && state.selectedType.length > 1) {
                    state.selectedType = state.selectedType.filter((v) => v !== "all");
                }

                const allKeys = (type_list ?? []).map((c) => c.key);
                if (allKeys.every((key) => state.selectedType.includes(key))) {
                    state.selectedType = ["all"];
                }

                if (state.selectedType.length === 0) {
                    state.selectedType = ["all"];
                }
                state.page = 1;
                getList();
            };

            const viewImage = async (param: string) => {
                state.modalTab = 11;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            const showModal = async (type: number, idx: number) => {
                const res = await apiService.board.detail(type, idx);

                if (res.returnCode === 0) {
                    switch (type) {
                        case 1:
                            {
                                state.activityInfo = res.data;
                                state.isActivityShowModal = true;
                            }
                            break;
                        case 2:
                            {
                                state.eventInfo = res.data;
                                state.isEventShowModal = true;
                            }
                            break;
                        case 4:
                            {
                                state.newsInfo = res.data;
                                state.isNewsShowModal = true;
                            }
                            break;
                    }
                }
            };

            const addActivity = () => {
                state.activityInfo = null;
                state.isActivityShowModal = true;
            };

            const addEvent = () => {
                state.eventInfo = null;
                state.isEventShowModal = true;
            };

            const addNews = () => {
                state.newsInfo = null;
                state.isNewsShowModal = true;
            };

            return {
                state,
                user,
                router,
                closeModal,
                callBackModal,
                imgError,
                types,
                CommonUtils,

                global,
                popup,
                type_list,
                getList,
                strBoardType,
                strState,
                handlePageChange,
                form_state,
                searchDate,
                isMain,
                toggleAllRole,
                handleRoleChange,
                state_list,
                apply_state_list,
                viewImage,
                showModal,

                addActivity,
                addEvent,
                addNews,
            };
        },
    };
</script>
<style scoped></style>
